/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'raigmore/dropdown': {
    width: 34,
    height: 34,
    viewBox: '0 0 34 34',
    data: '<rect pid="0" width="34" height="34" rx="6" _fill="#E2E2F5"/><path pid="1" d="M17.043 23.999c.342-.009.668-.154.916-.41l8.62-9.003c.548-.576.563-1.527.035-2.125a1.307 1.307 0 00-1.953-.044L17 20.424l-7.66-8.007a1.307 1.307 0 00-1.954.044c-.528.598-.513 1.549.035 2.124l8.62 9.003c.27.279.63.427 1.002.41z" _fill="#4547BF"/>'
  }
})
